//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ExchangeSynchronizationConflictResolutionMode {
	NeverOverwrite = 0,
	AutoResolve = 1,
	AlwaysOverwrite = 2
}
